/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FormSection } from './FormSection'
import { Tag } from './Tag'

export class FormLayout {
  constructor(json: JSON | any) {
    Object.assign(this as FormLayout, json)
  }

  name?: string
  width?: number
  height?: number
  descr?: string
  tag?: Tag
  guid?: string
  group?: string
  sections?: Array<FormSection>
  importedServiceXPaths?: Array<string>
}
